import { render, staticRenderFns } from "./QuizQuestionsCreator.vue?vue&type=template&id=a32b4bac&scoped=true&"
import script from "./QuizQuestionsCreator.vue?vue&type=script&lang=js&"
export * from "./QuizQuestionsCreator.vue?vue&type=script&lang=js&"
import style0 from "./QuizQuestionsCreator.vue?vue&type=style&index=0&id=a32b4bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32b4bac",
  null
  
)

export default component.exports